module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTD11/zx2/zp2/zl0/zp0/zx0/zp2/z5+/zp0/zhy/z50/z52/3Ng9qMAAAAMdFJOUwDS6fmlvY1ECHQWXvNVBeYAAADDSURBVDjLY2AYrGCpzRlUcDgKIhFzBh0chUjYYEgchkicOTTlzJFJZzR9EDJQieMMMgLsNhtYMSROMwhrsJ+ZgClx2PHMQeczJjHoEjgt98GQOAKRaBNEBxnkhtUSISU04IXLchNCYYVwZvIZtZgzYTpn0CUCuM8UMB5kqMGU6D5T0HiQA1MCzSjSw2oJuv8UvcgNq7ZAHMGO03LcYYUrMQCTj4wC1uQDTnBnsCS4Q1MOH5lkg5lEcVqOMxvgzDjDAQAAJ4RnAaNTbg8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_22_zh.png
// module id = wf2D
// module chunks = 34